/*--------------------------------------------------
|          Functions + external libraries
|---------------------------------------------------|
*/

/**
 *
 * Load script dynamically and instantly trigger a function
 *
 * @param {string} sSrc
 *   Script JS to be loaded
 *
 * @param {function} fOnload
 *   Function to be triggered when the file is completely loaded
 *
 */

export default function (sSrc, fOnload) {
  var oScript = document.createElement("script");
  oScript.type = "text\/javascript";
  if (fOnload) { oScript.onload = fOnload; }
  document.getElementsByTagName("head")[0].appendChild(oScript, document.currentScript);
  oScript.src = sSrc;
}




// WEBPACK FOOTER //
// ./src/scripts/helpers/import-script.js